import Loading from "./CLoading/index";

export default Loading;
